import { IParseJackpotsProps, TParseJackpotsReturn } from './types';

export const parseJackpotsXMLBP = (xmlDoc: IParseJackpotsProps): TParseJackpotsReturn => {
    const jackpotCurrency = xmlDoc?.getElementsByTagName('jackpots')[0].getAttribute('currency');

    return [...xmlDoc.getElementsByTagName('jackpot')].reduce((acc: TParseJackpotsReturn, gameDataNode) => {
        acc[gameDataNode.id] = {
            currencyCode: jackpotCurrency?.toLowerCase(),
            step: Number(gameDataNode.getAttribute('step') || 0.01),
            amount: Number(gameDataNode.getAttribute('current_amount')) * 0.99,
            originAmount: Number(gameDataNode.getAttribute('current_amount')),
            hitTime: null
        };
        return acc;
    }, {});
};
